import React from "react";

import { IGameTableType } from "@/types/GlobalTypes";
import Nnary from "@/modules/Nnary";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";

import SlBet from "../../SlBet";
import DiamondDiv from "../../DiamondDiv";
import { fortyEightDReds } from "@/modules/commonMobile";
import nary from "@/modules/nary";

import "./index.scss";
import zeroFill from "@/modules/zeroFill";
import nth0 from "@/modules/nth0";
import MultibetGenerator from "../../MultibetGenerator";

export default class M35 extends React.Component<IGameTableType> {
    state = { activeHover: "" };

    render() {
        //Done: add win indicators

        const { langdata, maximised, mobile, portrait } = this.props;
        const win = this.props.win ? Number(this.props.win) : null;

        const showPrize = maximised || mobile;

        const winIndicatorColumn = (start, end) => {
            if (!win)
                return false

            return (win >= start && win <= (start + end))
        }

        const winIndicatorRows = (start, double = false) => {
            if (!win)
                return false
            
            if (double)
                return ( Nnary(start, 44 + start, 4).indexOf(win) >= 0 || 
                        Nnary(start + 1, 44 + start + 1, 4).indexOf(win) >= 0 )
            
            return (Nnary(start, 44 + start, 4).indexOf(win) >= 0)
        }

        // Not portrait
        const sideBets = [
            ["Small", "Odd", "Red"],
            ["Big", "Even", "Black"]
        ];

        const sideBetsWinStatement = [
            [(win >= 1 && win <= 24), (win % 2 !== 0), (fortyEightDReds.indexOf(win) >= 0)],
            [(win >= 25 && win <= 48), (win !== null && win % 2 === 0), (win !== null && fortyEightDReds.indexOf(win) < 0)]
        ]

        const centreColumns = Nnary(0, 44, 4);

        //All screen modes except portrait
        const sideBetGenerator = (bet: string, winStatement: boolean) => (
            <SlBet key={"m35_g_b_" + bet}

                classes="sl-bet sl-green-old"
                bet={bet}
                group="n50"

                winStatement={winStatement}

                betLabel={
                    bet === "Red" || bet === "Black" ?
                        <DiamondDiv colour={bet.toLowerCase() === "red" ? "#b83432" : "#1f2022"} /> :
                        ("txt_" + bet.toLowerCase()) in langdata ?
                            langdata["txt_" + bet.toLowerCase()] :
                            bet}
                betType={showPrize ? "1:0.95" : null}

                {...commonBetProps}
                {...commonHoverProps}
            />
        );

        const commonBetProps = {
            pcode: this.props.pcode,
            chipBase: this.props.chipBase,
            mobile: this.props.mobile,
            bets: this.props.bets,
            insertBet: this.props.insertBet,
            betOutOfBounds: this.props.betOutOfBounds,
            langStr: langdata.language_code
        };

        //Only use this if the SlBet has hover parameters
        const commonHoverProps = {
            hasHover: true,
            mouseOver: mouseOver.bind(this),
            mouseLeave: mouseLeave.bind(this)
        };

        const commonMultiBetProps = {
            ...commonBetProps,
            ...commonHoverProps
        }

        const redClass = "sl-red-lighten";
        const blackClass = "sl-black-lighten";
        if (portrait)
            return (
                <div className="sl-table m35-portrait">
                    {
                        [
                            ["Small", "Big"],
                            ["Odd", "Even"],
                            ["Red", "Black"]
                        ].map((rows, idx) =>
                            <div key={"portarit_m35_row_" + idx} className="row">
                                {
                                    rows.map((cell, rowIdx) => {
                                        const winStatements = win ?
                                        sideBetsWinStatement[rowIdx][idx] :
                                        false

                                        return (
                                            <SlBet key={"portrait_m35_g_" + cell}

                                                classes={"sl-bet col-xs-6 " +
                                                    (cell === "Red" ? redClass :
                                                        cell === "Black" ? blackClass :
                                                            "sl-green-old")
                                                }
                                                bet={cell}
                                                group="n50"

                                                winStatement={winStatements}

                                                betLabel={
                                                    ("txt_" + cell.toLowerCase()) in langdata ?
                                                        langdata["txt_" + cell.toLowerCase()] : cell
                                                }
                                                betType="1:0.95"

                                                {...commonBetProps}
                                            />
                                        )
                                    })
                                }
                            </div>
                        )
                    }

                    <div className="row">
                        <div className="col-xs-2 side">
                            {
                                nary(11).map((num, numIdx) => {
                                    // const n1 = (numIdx * 4) + 1
                                    // const winStatementColBot = (win >= n1 && win <= (n1 + 7))
                                    return (
                                        <SlBet key={"m35_g_" + num}

                                            classes={"sl-bet col-xs-12 taller sl-green-old"}
                                            bet={`${nth0(numIdx)} Column,${nth0(numIdx + 1)} Column`}
                                            group="n8"

                                            winStatement={winIndicatorColumn((numIdx * 4) + 1, 7)}

                                            betLabel={`${langdata["txt_line"]} ${num} & ${num + 1}`}
                                            betType="1:4.5"

                                            {...commonBetProps}
                                        />
                                    )
                                })
                            }
                        </div>

                        <div className="col-xs-8">
                            {
                                // Top Row Labels
                            }
                            <div>
                                {
                                    Nnary(1, 4).map(num =>
                                        <SlBet key={"m35_g_" + num}

                                            classes={"sl-bet col-xs-3 sl-green-old"}
                                            bet={`${nth0(num - 1)} Row`}
                                            group="n12"

                                            winStatement={winIndicatorRows(num, )}

                                            betLabel={`${langdata["txt_row"]} ${num}`}
                                            betType="1:2.8"

                                            {...commonBetProps}
                                        />
                                    )
                                }
                            </div>

                            {
                                // 01, 02, 03, 04
                            }
                            {
                                centreColumns.map((col, idx) =>
                                    <div key={"m35_centre_" + idx}>
                                        {
                                            Nnary(1, 4).map(row => {
                                                const computed = col + row;

                                                return (
                                                    <SlBet key={"m35_g_" + computed}

                                                        classes={"sl-bet col-xs-3" +
                                                            (fortyEightDReds.indexOf(computed) >= 0 ? " sl-red-lighten" : " sl-black-lighten")
                                                        }
                                                        bet={zeroFill(computed, 2)}
                                                        group="n"

                                                        winStatement={win ? Number(win) === Number(computed) : false}

                                                        betLabel={zeroFill(computed, 2)}
                                                        betType="1:44"

                                                        {...commonBetProps}
                                                    />
                                                );
                                            })
                                        }
                                    </div>
                                )
                            }

                            {
                                // Bottom
                                // Row A & B
                            }
                            <div>
                                {
                                    Nnary(1, 3, 2).map(num =>
                                        <SlBet key={"m35_g_" + num}

                                            classes={"sl-bet col-xs-6 sl-green-old"}
                                            bet={`${nth0(num - 1)} Row,${nth0(num)} Row`}
                                            group="n24"

                                            winStatement={winIndicatorRows(num, true)}

                                            betLabel={`${langdata["txt_row"]} ${num} & ${num + 1}`}
                                            betType="1:0.95"

                                            {...commonBetProps}
                                        />
                                    )
                                }
                            </div>
                        </div>

                        <div className="col-xs-2 side">
                            {
                                nary(12).map((num, numIdx) => {
                                    // const n1 = (numIdx * 4) + 1
                                    // const winStatementColTop = win ? (win >= n1 && win <= (n1 + 3)) : false
                                    return (
                                        <SlBet key={"m35_g_" + num}

                                            classes={"sl-bet col-xs-12 sl-green-old"}
                                            bet={`${nth0(numIdx)} Column`}
                                            group="n4"

                                            winStatement={winIndicatorColumn((numIdx * 4) + 1, 3)}

                                            betLabel={`${langdata["txt_line"]} ${num}`}
                                            betType="1:10"

                                            {...commonBetProps}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>

                    <MultibetGenerator
                        keyPattern={
                            Nnary(0, 40, 4).map(row =>
                                nary(4).map(cell => {
                                    const computed = row + cell;
                                    return `${zeroFill(computed, 2)},${zeroFill(computed + 4, 2)}`;
                                })
                            )
                        }

                        langdata={langdata}

                        firstLeftPercent={100 / 4}
                        firstTopPercent={29.5}

                        leftSpace={100 / 6 + "%"}
                        topSpace={6 + "vh"}

                        width={50}
                        height={10}

                        betGroup="n2"

                        {...commonMultiBetProps}
                    />

                    <MultibetGenerator
                        keyPattern={
                            Nnary(0, 44, 4).map(row =>
                                nary(3).map(cell => {
                                    const computed = row + cell;
                                    return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)}`;
                                })
                            )
                        }

                        langdata={langdata}

                        firstLeftPercent={100 / 3}
                        firstTopPercent={26.5}

                        leftSpace={100 / 6 + "%"}
                        topSpace={6 + "vh"}

                        width={10}
                        height={40}

                        betGroup="n2"

                        {...commonMultiBetProps}
                    />

                    <MultibetGenerator
                        keyPattern={
                            Nnary(0, 40, 4).map(row =>
                                nary(3).map(cell => {
                                    const computed = row + cell;
                                    return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)},` +
                                        `${zeroFill(computed + 4, 2)},${zeroFill(computed + 5, 2)}`;
                                })
                            )
                        }

                        langdata={langdata}

                        firstLeftPercent={100 / 3}
                        firstTopPercent={29.5}

                        leftSpace={100 / 6 + "%"}
                        topSpace={6 + "vh"}

                        width={25}
                        height={25}

                        betGroup="n4"

                        {...commonMultiBetProps}
                    />
                </div>
            );

        return (
            <div className="sl-table table-m35">
                <div className="side">
                    {sideBets[0].map((bet, idx) => sideBetGenerator(bet, sideBetsWinStatement[0][idx]))}
                </div>
                <div className="centre">
                    <div className="top">
                        <div className="column-heads">
                            {
                                nary(12).map((num, numIdx) =>
                                    <SlBet key={"m35_g_heads_" + num}

                                        classes="sl-bet sl-green-old"
                                        bet={`${nth0(numIdx)} Column`}
                                        group="n4"

                                        winStatement={winIndicatorColumn((numIdx * 4) + 1, 3)}

                                        betLabel={`${langdata["txt_line"]} ${num}`}
                                        betType={showPrize ? "1:10" : null}

                                        {...commonBetProps}
                                        {...commonHoverProps}
                                    />
                                )
                            }
                        </div>
                        <div className="columns">
                            <div className="rows-left">
                                {
                                    nary(4).map((row, rowIdx) =>
                                        <SlBet key={"m35_g_left_" + row}

                                            classes="sl-bet sl-green-old"
                                            bet={`${nth0(rowIdx)} Row`}
                                            group="n12"

                                            winStatement={winIndicatorRows(row)}

                                            betLabel={`${langdata["txt_row"]} ${row}`}
                                            betType={showPrize ? "1:2.8" : null}

                                            {...commonBetProps}
                                            {...commonHoverProps}
                                        />
                                    )
                                }
                            </div>

                            <div className="cell-collection">
                                {
                                    nary(4).map((row, idx) =>
                                        <div key={"m35_row_g_" + idx}>
                                            {
                                                centreColumns.map(col => {
                                                    const computed = col + row;
                                                    const { activeHover } = this.state;

                                                    const parsedActiveHover = parseInt(activeHover, 10);

                                                    return (
                                                        <SlBet key={"m35_g_" + row + "_" + col}

                                                            classes={"sl-bet " + (fortyEightDReds.indexOf(computed) >= 0 ? "sl-red-lighten" : "sl-black-lighten")}
                                                            bet={zeroFill(computed, 2)}
                                                            group="n"

                                                            hoverStatement={
                                                                //multibet
                                                                (activeHover.indexOf(zeroFill(computed, 2)) >= 0 &&
                                                                    activeHover.indexOf(" ") < 0) ||

                                                                //top
                                                                (activeHover.indexOf("Column") >= 0 &&
                                                                    computed > (parsedActiveHover - 1) * 4 &&
                                                                    computed <= parsedActiveHover * 4) ||

                                                                //bottom (top & bottom has the same "Column" text but this one also has comma)
                                                                (activeHover.indexOf("Column,") >= 0 &&
                                                                    computed > (parsedActiveHover - 1) * 4 &&
                                                                    computed <= (parsedActiveHover + 1) * 4) ||

                                                                //left side
                                                                (activeHover === `${nth0(row - 1)} Row`) ||

                                                                //right side
                                                                (activeHover.indexOf("Row,") >= 0 &&
                                                                    (computed % 4 === parsedActiveHover ||
                                                                        computed % 4 === (parsedActiveHover + 1 === 4 ? 0 : parsedActiveHover + 1))) ||



                                                                //small/big
                                                                (activeHover === "Small" && computed <= 24) ||
                                                                (activeHover === "Big" && computed >= 25) ||

                                                                //odd/even
                                                                (activeHover === "Odd" && !!(computed % 2)) ||
                                                                (activeHover === "Even" && !(computed % 2)) ||

                                                                //red/black
                                                                (activeHover === "Red" && fortyEightDReds.indexOf(computed) >= 0) ||
                                                                (activeHover === "Black" && fortyEightDReds.indexOf(computed) < 0)
                                                            }

                                                            winStatement={win ? Number(win) === computed : false}

                                                            betLabel={computed + ""}
                                                            betType={showPrize ? "1:44" : null}

                                                            {...commonBetProps}
                                                        />
                                                    );
                                                })
                                            }
                                        </div>
                                    )
                                }
                            </div>

                            <div className="rows-right">
                                {
                                    nary(2).map((row, rowIdx) =>
                                        <SlBet key={"m35_g_row_" + row}

                                            classes="sl-bet sl-green-old"
                                            bet={`${nth0(rowIdx * 2)} Row,${nth0(rowIdx * 2 + 1)} Row`}
                                            group="n24"

                                            winStatement={winIndicatorRows((rowIdx * 2) + 1 , true)}

                                            betLabel={`${langdata["txt_row"]} ${rowIdx * 2 + 1} & ${rowIdx * 2 + 2}`}
                                            betType={showPrize ? "1:0.95" : null}

                                            {...commonBetProps}
                                            {...commonHoverProps}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <div className="bottom">
                        {
                            nary(11).map((num, numIdx) =>
                                <SlBet key={"m35_g_row_" + num}

                                    classes="sl-bet sl-green-old"
                                    bet={`${nth0(numIdx)} Column,${nth0(numIdx + 1)} Column`}
                                    group="n8"

                                    winStatement={winIndicatorColumn((numIdx * 4) + 1, 7)}

                                    betLabel={`${langdata["txt_line"]} ${numIdx + 1} & ${numIdx + 2}`}
                                    betType={showPrize ? "1:4.5" : null}

                                    {...commonBetProps}
                                    {...commonHoverProps}
                                />
                            )
                        }
                    </div>
                </div>

                <div className="side">
                    {sideBets[1].map((bet, idx) => sideBetGenerator(bet, sideBetsWinStatement[1][idx]))}
                </div>

                {/* MULTIBET STARTS HERE */}
                {
                    /*
                        Pattern:
                        01,05  05,09
                        02,06  06,10
                    */
                }
                <MultibetGenerator
                    keyPattern={
                        nary(4).map(row =>
                            Nnary(0, 40, 4).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 4, 2)}`;
                            })
                        )
                    }

                    langdata={langdata}

                    firstLeftPercent={3 / 16 * 100}
                    firstTopPercent={25}

                    leftSpace={100 / 16 + "%"}
                    topSpace={100 / 6 + "%"}

                    width={8}
                    height={28}

                    betGroup="n2"

                    {...commonMultiBetProps}
                />

                {
                    /*
                        Pattern:
                        01,02  05,06
                        02,03  06,07
                    */
                }
                <MultibetGenerator
                    keyPattern={
                        nary(3).map(row =>
                            Nnary(0, 44, 4).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)}`;
                            })
                        )
                    }

                    langdata={langdata}

                    firstLeftPercent={5 / 32 * 100}
                    firstTopPercent={1 / 3 * 100}

                    leftSpace={100 / 16 + "%"}
                    topSpace={100 / 6 + "%"}

                    width={showPrize ? 60 : 30}
                    height={8}

                    betGroup="n2"

                    {...commonMultiBetProps}
                />

                {
                    /*
                        Pattern:
                        01,02,05,06  05,06,09,10
                        02,03,06,07  06,07,10,11
                    */
                }
                <MultibetGenerator
                    keyPattern={
                        nary(3).map(row =>
                            Nnary(0, 40, 4).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)},` +
                                    `${zeroFill(computed + 4, 2)},${zeroFill(computed + 5, 2)}`;
                            })
                        )
                    }

                    langdata={langdata}

                    firstLeftPercent={3 / 16 * 100}
                    firstTopPercent={1 / 3 * 100}

                    leftSpace={100 / 16 + "%"}
                    topSpace={100 / 6 + "%"}

                    width={16}
                    height={16}

                    betGroup="n4"

                    {...commonMultiBetProps}
                />
            </div>
        );
    }
}